<template>
    <div class="t-panel">
      <div class="panel-icon" v-if="option.icon" :style="{height:height,lineHeight:height,width:height}">
        <slot name="icon">
          <i class='icon icon-integrate' :class="'icon-'+option.icon" :style="{color:option.color}"></i>
        </slot>
      </div>
      <div class="panel-box" :style="{height:height,lineHeight: height}" :class="[{'has-border': border},{'has-icon': option.icon }]" @click="onPath()">
        <p>{{option.text}}</p>
        <div class="panel-right">
          <slot></slot>
          <i v-if="next" class="icon icon-next"></i>
        </div>
      </div>
    </div>
</template>
<script>
/**
 * @param option [Object] 参数包含,icon(图标)，text(标题),color(图标颜色)
 * @param height [String] 栏目高度,默认44rem
 * @param border [Boolean] 是否显示底部边框
 * @param border [Boolean] 是否显示下一步
 * @param next [Function] 点击下一步事件
 * @describe
 *
 * @example
 *
  <t-panel border next :option="{icon:'integrate',text:'我的积分'}"></t-panel>
 */
export default {
  name: 'tPanel',
  props: {
    option: {
      type: Object,
      default() {
        return {
          icon: '',
          color: '',
          text: '',
        };
      },
    },
    height: {
      type: String,
      default: '0.44rem',
    },
    border: {
      type: Boolean,
      default: false,
    },
    next: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    onPath: function () {
      this.$emit('next');
    },
  },
};

</script>
<style lang="scss">
@import "../style/mixin";

.t-panel {
  background-color: #ffffff;
  .panel-icon {
    float: left;
    text-align: center;
    i {
      color: #FC6A00;
      font-size: 0.22rem;
    }
  }
  .panel-box {
    padding-left: 0.16rem;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    &.has-icon {
      padding-left: 0 !important;
    }
    &.has-border {
      @include border-1px-b(#dedede);
    }
    p {
      font-size: 0.14rem;
      color: #292929;
    }
    .panel-right {
      position: absolute;
      top: 0;
      right: 0.12rem;
      color: #909090;
      i {
        float: right;
        font-size: 0.14rem;
        margin-left: 0.02rem;
        color: #ccc;
      }
      span {
        float: left;
        font-size: 0.13rem;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/panel.vue